import { render, staticRenderFns } from "./assay.vue?vue&type=template&id=5d868b45&"
import script from "./assay.vue?vue&type=script&lang=js&"
export * from "./assay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports